import { DefaultService } from '@/services/DefaultService';

/* @71168 */
/* @71170 */
export default class PlanoSafraService extends DefaultService {

	constructor(http, router, env) {
			super(http, router, env);
	}

	save(agroplanosafra) {
		return this._http.post(`${this._env}/agro/agro-planosafra`, agroplanosafra, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	find(id) {
		return this._http.get(`${this._env}/agro/agro-planosafra/${id}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findByUuid(uuid) {
		return this._http.get(`${this._env}/agro/agro-planosafra/uuid/${uuid}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAll(filtro, column, order, page = 0, limit = 20, ...params) {
		return this._http.post(encodeURI(`${this._env}/agro/agro-planosafra.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), filtro, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}
    
	updateSituacao(agroplanosafra) {
		return this._http.post(`${this._env}/agro/agro-planosafra/updatesituacao`, agroplanosafra, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

  findSafra() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/safra?`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

  findEmpresa() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/empresa?`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

  loadSafra() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/loadsafra`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

  loadEmpresa() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/loadempresa`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

  loadCliente() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/loadcliente`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

  loadNivelTecnologico() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/loadniveltecnologico`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

  loadCultivar() {
		return this._http.get( encodeURI(`${this._env}/agro/agro-planosafra/laodcultivar`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	loadOrigem() {
		return this._http.get( encodeURI(`${this._env}/system/audit/origens.json`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/agro/agro-planosafra/getcombo.json?param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

}